import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';

export const ORG_FEATURE_KEYS_QUERY_KEY = 'org-feature-keys';

/**
 * Returns the active FEATURE entitlement key strings for the given org scope.
 * Used by the roles modal to determine which feature-axis roles (ADMIN, PROCUREMENT) are unlocked.
 */
export function useOrgFeatureKeys(scopeType: string | undefined, scopeId: string | undefined) {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [ORG_FEATURE_KEYS_QUERY_KEY, scopeType, scopeId],
    queryFn: async (): Promise<string[]> => {
      const token = await getToken();
      const url = new URL(`${import.meta.env.VITE_API_URL}/entitlements/feature-keys`);
      url.searchParams.set('scopeType', scopeType!);
      url.searchParams.set('scopeId', scopeId!);
      const result = await sendJSONRequest({ url: url.toString(), method: METHOD.GET, token: token ?? '' });
      return (result as { featureKeys: string[] }).featureKeys;
    },
    enabled: !!scopeType?.trim() && !!scopeId?.trim(),
    // Feature grants change infrequently; a 1-minute stale time keeps the modal snappy
    staleTime: 60_000,
  });
}
